import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from "@/store/authentication.js";

const user_role = auth.state.user_role;
const userMenuPermissions = auth.state.menu_permissions;

let currentURL = (window.location.pathname !== '/' ? window.location.pathname : '');
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Account/Dashboard.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/profile',
    name: 'Mi cuenta',
    component: () => import('../views/Account/Cuenta.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/proyectos',
    name: 'Proyectos',
    component: () => import('../views/Proyectos.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/proyectos/:mode/:id?',
    name: 'ProyectoDetalle',
    component: () => import('../views/Proyecto/Detalle.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/proyectos/:mode/:id?/:editProposal?',
    name: 'ProyectoDetalleProposal',
    component: () => import('../views/Proyecto/Detalle.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: () => import('../views/Pedidos.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'pedidos'}
  },
  {
    path: '/pedidos/:mode/:id?',
    name: 'PedidoDetalle',
    component: () => import('../views/Pedido/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'pedidos'}
  },
  {
    path: '/eventos',
    name: 'Eventos',
    component: function () {
      if (user_role == 'admin') {
        return import('../views/AdminEventos.vue');
      } else {
        return import('../views/AdminEventos.vue');
      }
    },
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'eventos'}
  },
  {
    path: '/pagos',
    name: 'Pagos',
    component: () => import('../views/Pagos.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'pagos'}
  },
  {
    path: '/pagos/:mode/:id?',
    name: 'PagoDetalle',
    component: () => import('../views/Pago/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'pagos'}
  },
  {
    path: '/asociados',
    name: 'Asociados',
    component: () => import('../views/Asociados.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/asociados/:mode/:id?',
    name: 'AsociadoDetalle',
    component: () => import('../views/Asociado/Detalle.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/administradores',
    name: 'Administradores',
    component: () => import('../views/Administradores.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/administradores/:mode/:id?',
    name: 'AdministradorDetalle',
    component: () => import('../views/Administrador/Detalle.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/proveedores',
    name: 'Proveedores',
    component: () => import('../views/Proveedores.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/proveedores/:mode/:id?',
    name: 'ProveedorDetalle',
    component: () => import('../views/Proveedor/Detalle.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/eventos/:mode/:id?',
    name: 'EventoDetalle',
    component: () => import('../views/Evento/Detalle.vue'),
    meta: {requiresAdmin: false}
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import('../views/Clientes.vue'),
    meta: {requiresPartner: true, requiresPartnerMenuPermission: 'clientes'}
  },
  {
    path: '/clientes/:mode/:id?',
    name: 'ClienteDetalle',
    component: () => import('../views/Cliente/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'clientes'}
  },
  {
    path: '/packs',
    name: 'Promopacks',
    component: () => import('../views/Packs.vue')
  },
  {
    path: '/packs/:mode/:id?',
    name: 'PackDetalle',
    component: () => import('../views/Pack/Detalle.vue')
  },
  {
    path: '/packs/:mode/:id?',
    name: 'PackDetalleSetup',
    component: () => import('../views/Pack/DetalleSetup.vue')
  },
  {
    path: '/packs-frontal',
    name: 'PacksFrontal',
    component: () => import('../views/PackFrontal/PackFrontalList.vue')
  },
  {
    path: '/pack-frontal/:mode/:pack_code?',
    name: 'PackFrontalDetalle',
    component: () => import('../views/PackFrontal/PackFrontalDetalle.vue')
  },
  {
    path: '/banco-imagenes',
    name: 'Banco de imagenes',
    component: () => import('../views/BancoImagenes.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/material-de-ventas',
    name: 'Material de ventas',
    component: function () {
      if (user_role == 'admin') {
        return import('../views/AdminMaterialVentas.vue');
      } else {
        return import('../views/MaterialVentas.vue');
      }
    },
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'material-de-ventas'}
  },
  {
    path: '/material-de-ventas/:mode/:id?',
    name: 'MaterialDetalle',
    component: () => import('../views/Material/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'material-de-ventas'}
  },
  {
    path: '/formacion',
    name: 'Formacion',
    component: () => import('../views/Formacion.vue'),
    meta: {requiresLogin: true}
  },

  {
    path: '/noticias',
    name: 'Noticias',
    component: function () {
      //REMOVE BEFORE COMMIT
      if (user_role == 'admin') {
        return import('../views/AdminNoticias.vue');
      } else {
        return import('../views/Noticias.vue');
      }
    },
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'noticias'}
  },
  {
    path: '/noticias/:id?',
    name: 'NoticiaDetalleFront',
    component: () => import('../views/Noticia/DetalleFront.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'noticias'}
  },
  {
    path: '/noticias/:mode/:id?',
    name: 'NoticiaDetalle',
    component: () => import('../views/Noticia/Detalle.vue'),
    meta: {requiresAdmin: true}
  },
  {
    path: '/tickets',
    name: 'Tickets',
    component: () => import('../views/Tickets.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'tickets'}
  },
  {
    path: '/tickets/:id/:project',
    name: 'TicketDetalle',
    component: () => import('../views/Ticket/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'tickets'}
  },
  {
    path: '/contactos',
    name: 'Contacto',
    component: () => import('../views/Contacto.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'contactos-internos'}
  },
  {
    path: '/contactos/:mode/:id?',
    name: 'ContactDetalle',
    component: () => import('../views/Contacto/Detalle.vue'),
    meta: {requiresLogin: true, requiresPartnerMenuPermission: 'contactos-internos'}
  },
  {
    path: '/store/:mode/:id?',
    name: 'StoreDetalle',
    component: () => import('../views/Store/Detalle.vue'),
    meta: {requiresLogin: true}
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('../views/Forbidden')
  },
  {
    path: '/login',
    name: 'LoginPartner',
    component: () => import('../views/AuthenticationPartner')
  },
  {
    path: '/admin/login',
    name: 'LoginAdmin',
    component: () => import('../views/AuthenticationAdmin')
  },
  {
    path: '/password/reset/:id?',
    name: 'ResetPassword',
    component: () => import('../views/RestorePassword')
  },
  {
    path: "/securedownload/:id",
    name: "SecureDownload",
    component: () => import('../views/SecureDownload'),
    meta: {requiresLogin: true}
  },
  {
    path: '/logout',
    name: 'Logount',
    component: () => {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_role");
      localStorage.removeItem("user");
      localStorage.removeItem("menu_permissions");
      localStorage.removeItem("project_permissions");
      localStorage.removeItem("gallery_link");
      router.push('login');
      location.reload();
    }
  }
];

const router = new VueRouter({
  base: currentURL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin)) {
    if (user_role === null) {
      if (to.name === 'SecureDownload') {
        localStorage.setItem('redirect', to.params.id)
      }
      next({
        path: "/login"
      });
      return;
    }
  }
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (user_role != 'admin') {
      next({
        path: "/forbidden",
      });
      return;
    }
  }
  if (to.matched.some(record => record.meta.requiresPartner)) {
    if (user_role == 'customer') {
      next({
        path: "/forbidden",
      });
      return;
    }
  }

  if (user_role === 'partner') {
    const permissions = to.matched.map(record => record.meta.requiresPartnerMenuPermission).filter((Boolean));

    if (permissions.length !== 0) {

      const hasPermission = permissions.every(permission => userMenuPermissions.includes(permission));

      if (!hasPermission) {
        next({
          path: "/forbidden",
        });
        return;
      }
    }
  }

  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js